module.exports = __webpack_public_path__ + "static/img/Newimg7.3a461da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Newimg7.png
// module id = c4f7
// module chunks = 36